export enum DialogAction {
	ADD = 'ADD',
	EDIT = 'EDIT',
}
